var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_24_664",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_24_664",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACX0lEQVR4nO2dvYoUQRRG20BfZnURjEQDcbPFrDlfzRNMYqaIieBmiqBgIIYq/iTGZqaG+gaCrBromhiqCyslK8jSI9tO9y2n6ztQYc/cOtzpvtVVl2kaY4wxxhhjjDH/L8BJSY+Bj8B3SR8kPZR0vHRsk0HSZUm7kvY6xg/gYukYVx5ga4Hgg+Na6VhrkLxn2XGSLTtQsmUHSrbsQMmWHSj513DpFyQ619lt264d/L6qYTzZD0rPrQrZwHbpedUi+1vpOdUi+33p+VQhG3jU1CYO2Op7zZKid2ez2XpTC/whLFI2cKmpBbpF3ez5GVf/QfT1phb4ezaOKduSNb5sS9b4mW3JGl+2JWt82ZasfuVY79Kv7zUrDcMumXtldjUwzutNyw56h2zZQZItO1By3bKJlVynbMpIzsN1sizZmbxS4NuFJU8CnMmWPAlwJlvyJMCZbMmTwJkcgCUHYMkBWHIAlhyAJQdgyQFYcgCWHMB8Pj8KnEopbQBXcuNMxB4fNR3T6gI4bclBGZ7bdp3JAUj64iMBAUh663MXAQCv/eALAHjpE0QBSHruY1oBSLrtOjkA4LwXI0sCnDjMqiyldE7SLUlPgRfAK+DNfkWysPyrfsX3G0k3hhDStu0a8NWSuzki6d1Q2SfpjjO5A+DskD91STPfLrrF3B+yLSGltFHVSfser0N3hnyIAcfGiXaFSSldcMNNAJKeubspAEmf3UoWQP6TgUNsL21Lupu3tiJimiS5slggdwe4J+lMrrNLx7ny5Aohy97P7E/AE0mbuRopHZsxxhhjjDHGmGY5fgK4INP2IlkVdgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6e8d85671ab34f20b8a99ec71208cc8a.svg";
export { ForwardRef as ReactComponent };